import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "../../store/AuthSlice/thunk";
// import { resetStoreRef } from "../../store";
import { authActions } from "../../store/AuthSlice";
import { peopleActions } from "../../store/PeopleSlice";
import { modalActions } from "../../store/ModalSlice";
import { loadingActions } from "../../store/LoaderSlice";
import { managerActions } from "../../store/ManagerSlice";
import { requestActions } from "../../store/RequestSlice";
import { ATTENDANCE_URL } from "../../constants";
import LogoImg from "../../assets/icons/logo.svg";
import ProfileImg from "../../assets/icons/person.svg";
import HelpImg from "../../assets/icons/help.svg";
// import NotificationImg from "../../assets/icons/notifications.svg";
import AllModulesImg from "../../assets/icons/grid_view.svg";
import TaskBoxImg from "../../assets/icons/approval.svg";
// import DraftImg from "../../assets/icons/stylus_note.svg";
// import RequestImg from "../../assets/icons/requests.svg";
import ModuleImg from "../../assets/icons/module.svg";
import PeopleIcon from "../../assets/icons/people_new.svg";
// import AssestsIcon from "../../assets/icons/devices.svg";
import DocumentIcon from "../../assets/icons/documents.svg";
// import RecruitIcon from "../../assets/icons/person_search.svg";
import RequestIcon from "../../assets/icons/request_new.svg";
import AttendanceIcon from "../../assets/icons/attendance_new.svg";
import SeperationIcon from "../../assets/icons/dynamic_project_identifier.svg";
import StorePassIcon from "../../assets/icons/store_pass.svg";
import SubscriptionsIcon from "../../assets/icons/subscriptions.svg";
import AscentIcon from "../../assets/icons/ascenthr 1.svg";
// import CompportIcon from "../../assets/icons/Group.svg";
// import DostIcon from "../../assets/icons/image 2.svg";
import MediIcon from "../../assets/icons/Frame.svg";
import HappayIcon from "../../assets/icons/Group (1).svg";
import QuestIcon from "../../assets/icons/myBiz-Quest2Travel-logo1 1.svg";
import LearnIcon from "../../assets/icons/learn_side.svg";
import HelpdeskIcon from "../../assets/icons/helpdesk_sidebar_icon.svg";
import brandBayIcon from "../../assets/icons/brandBayIcon.svg";
import ProfileIcon from "../../assets/icons/account_circle.svg";
import ArrowIcon from "../../assets/icons/arrow_outward.svg";
import InitialsCircle from "../InitialsCircle";
import "./SideBar.css";
import { SSOAuthorization } from "more-sso-sdk";

const SideBar = ({ onNavigate = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const selectedPageRedux = useSelector((state) => state.auth.selectedPage);

  const [profileDrop, setProfileDrop] = useState(false);
  const selectedPage = location.pathname.startsWith("/")
    ? location.pathname.slice(1)
    : location.pathname;

  const profileTabSelected = useSelector(
    (state) => state.auth.profileTabSelected,
  );
  const roleType = useSelector(
    (state) => state.auth?.loginResponse?.body?.role_type,
  );
  const userDetailsResponseStatus = useSelector(
    (state) => state.auth.userDetailsResponseStatus,
  );
  const employeeID = useSelector((state) => state.auth.employeeID);
  const isUserLogged = useSelector((state) => state.auth.isLoggedIn);

  const getAllTaskboxResponse = useSelector(
    (state) => state.taskbox.getAllTaskboxResponse,
  );
  const fullName = useSelector(
    (state) => state.auth?.loginResponse?.display_name,
  );

  const accessToken = useSelector((state) => state.auth?.accessToken);
  const taskLength = useSelector((state) => state.taskbox.totalTaskLength);

  // useEffect(() => {
  //   let idleTimer = null;

  //   const checkLastPopupTime = () => {
  //     const user = JSON.parse(localStorage.getItem("user"));
  //     const lastPopupTime = new Date(user?.loginTime).getTime();
  //     const currentTime = new Date().getTime();

  //     // Check if 24 hours have passed since the last login
  //     if (
  //       (!lastPopupTime ||
  //         currentTime - lastPopupTime >= 24 * 60 * 60 * 1000) &&
  //       isUserLogged
  //     ) {
  //       dispatch(
  //         modalActions.setErrorModal({
  //           message: "Session Expired. Please re-login.",
  //           status: "error",
  //           state: true,
  //         })
  //       );
  //     }
  //   };

  //   const resetIdleTimer = () => {
  //     // Clear the existing idle timer
  //     clearTimeout(idleTimer);

  //     // Set a new idle timer for 15 minutes (or any desired duration)
  //     idleTimer = setTimeout(() => {
  //       checkLastPopupTime();
  //     }, 15 * 60 * 1000); // 15 minutes in milliseconds
  //   };

  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible") {
  //       checkLastPopupTime();
  //       resetIdleTimer(); // Reset the idle timer when the user comes back
  //     } else {
  //       clearTimeout(idleTimer); // Clear the idle timer when the user leaves the page
  //     }
  //   };

  //   // Add event listeners for user activity
  //   document.addEventListener("mousemove", resetIdleTimer);
  //   document.addEventListener("keydown", resetIdleTimer);
  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   // Initialize the idle timer
  //   resetIdleTimer();

  //   return () => {
  //     // Cleanup event listeners and timers
  //     document.removeEventListener("mousemove", resetIdleTimer);
  //     document.removeEventListener("keydown", resetIdleTimer);
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //     clearTimeout(idleTimer);
  //   };
  // }, [dispatch, isUserLogged]);

  useEffect(() => {
    if (userDetailsResponseStatus === "SUCCESS") {
      navigate("../profile");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetailsResponseStatus]);

  useEffect(() => {
    const currentPath = location.pathname.startsWith("/")
      ? location.pathname.slice(1)
      : location.pathname;
    dispatch(authActions.setSelectedPage(currentPath));
  }, [location.pathname, dispatch]);

  const navigateToPage = (path) => {
    dispatch(authActions.setSelectedPage(path));
    navigate(`/${path}`);
    if (window.innerWidth < 1024) {
      onNavigate();
    }
  };

  const handleClickOutside = (event) => {
    if (!profileDrop && event.target.className.includes("profile-drop-text")) {
      setProfileDrop(true);
    } else {
      setProfileDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ssoLogout = () => {
    SSOAuthorization.logout("https://people-sso.more.in/")
      .then(() => {
        dispatch(authActions.logout());
        console.log("Logged out successfully");
      })
      .catch((error) => {
        console.error("Logout failed", error);
      });
  };

  const ModuleBox = ({
    icon,
    moduleName,
    redirect = false,
    path = "/",
    url,
    notifyCount = false,
    count = 0,
  }) => (
    <div
      className={`module-box mb4 ${selectedPage === path ? "active" : ""}`}
      onClick={() => {
        if (path) {
          navigateToPage(path);
          dispatch(authActions.setSelectedPage(path));
        }
        if (url) {
          window.open(url, "_blank");
        }
      }}
    >
      <img className="module-icon" src={icon} alt="" />
      <div className="module-name">{moduleName}</div>
      {notifyCount && count > 0 && <div className="module-notify">{count}</div>}
      {redirect && <img src={ArrowIcon} className="arr-icon ml-auto" alt="" />}
    </div>
  );

  return (
    <div className="sidebar">
      <div className="flex w-full items-center justify-between gap-3">
        <img
          className="logo-img"
          src={LogoImg}
          alt=""
          onClick={() => {
            navigate("../all");
            dispatch(authActions.setSelectedPage("all"));
            if (window.innerWidth < 1024) {
              onNavigate();
            }
          }}
        />
        <button
          type="button"
          aria-label="Close sidebar"
          onClick={onNavigate}
          className="flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-lg leading-none text-slate-900 lg:hidden"
        >
          ×
        </button>
      </div>
      {location.pathname !== "/profile" && (
        <>
          <div className="flex">
            {/* <div className="flex notify-warpper">
              <img className="notify-img" src={NotificationImg} alt="" />
              <div className="msg-count-wrapper">
                <div className="msg-count-text">3 Unread</div>
              </div>aftaskbox
            </div> */}
          </div>
          {/* <div className="search-wrapper">
            <input
              className="side-search w-full"
              placeholder="Search for anything"
            />
          </div> */}
          <div className="flex flex-col main-modules">
            <div
              className={`flex items-center module-box ${
                selectedPage === "all" ? "active" : ""
              }`}
              onClick={() => navigateToPage("all")}
            >
              <img className="module-img" src={AllModulesImg} alt="all" />
              <div className="module-text">All Modules</div>
            </div>
            <div
              className={`flex items-center module-box ${
                selectedPage === "taskbox" ? "active" : ""
              }`}
              onClick={() => navigateToPage("taskbox")}
            >
              <img className="module-img" src={TaskBoxImg} alt="taskbox" />
              <div className="module-text">Taskbox</div>
              <div className="module-notify">
                {taskLength || 0}
                {}
              </div>
            </div>
          </div>
          {/* <div className="drafts">
            <div className="flex items-center draft-head">
              <img className="draft-icon" src={DraftImg} alt="" />
              <div className="draft-text">drafts</div>
            </div>
            <div className="request-wrapper">
              <div className="flex items-center w-full request-text-wrapper">
                <img className="request-icon" src={RequestImg} alt="" />
                <div className="request-text">Requests</div>
                <div className="request-count">11%</div>
              </div>
              <div className="shift-text">Shift Change</div>
            </div>
            <div className="draft-count">View 5 more drafts</div>
          </div> */}
          <div className="flex flex-col modules">
            <div className="flex mb-12">
              <img className="module-img" src={ModuleImg} alt="" />
              <div className="module-text">modules</div>
            </div>
            <ModuleBox
              icon={PeopleIcon}
              moduleName={"People"}
              path={"people"}
            />
            <ModuleBox
              icon={DocumentIcon}
              moduleName={"Documents"}
              path={"documents"}
            />
            {/* <ModuleBox
              icon={AssestsIcon}
              moduleName={"Assets"}
              path={"assets"}
            />
            <ModuleBox
              icon={RecruitIcon}
              moduleName={"Recruitment"}
              path={"recruitment"}
            />*/}
            <ModuleBox
              icon={RequestIcon}
              moduleName={"Requests"}
              path={"requests"}
            />

            <ModuleBox
              icon={SeperationIcon}
              moduleName={"Separation"}
              path={"separation"}
              notifyCount={true}
              count={getAllTaskboxResponse?.clearance_task_count || 0}
            />
            <ModuleBox
              icon={AttendanceIcon}
              moduleName={"Attendance & Leave"}
              redirect={false}
              path={"attendance"}
            />
            <ModuleBox
              icon={StorePassIcon}
              moduleName={"Store Pass"}
              path={"storepass"}
            />
            <ModuleBox
              icon={SubscriptionsIcon}
              moduleName={"Subscriptions"}
              path={"subscriptions"}
            />
            {/* <ModuleBox
              icon={AttendanceIcon}
              moduleName={"Attendance & Leave"}
              redirect={true}
              path={""}
              url={ATTENDANCE_URL}
            /> */}
            {/* <ModuleBox
              icon={CompportIcon}
              moduleName={"Compport"}
              redirect={true}
              path={""}
              url={"https://moreretail.compport.com/"}
            /> */}
            {/* <ModuleBox
              icon={DostIcon}
              moduleName={"YourDost"}
              redirect={true}
              path={""}
              url={"https://yourdost.com/userDashboard#/home"}
            /> */}
            <ModuleBox
              icon={MediIcon}
              moduleName={"Medi Assist"}
              redirect={true}
              path={""}
              url={"https://portal.medibuddy.in/Home.aspx"}
            />
            <ModuleBox
              icon={HappayIcon}
              moduleName={"Happay"}
              redirect={true}
              path={""}
              url={"https://expense.happay.in"}
            />
            <ModuleBox
              icon={AscentIcon}
              moduleName={"stoHRM"}
              redirect={true}
              path={""}
              url={"https://www.stohrm.com/stohrmwebapp/index.php/mrpl/admin"}
            />
            <ModuleBox
              icon={QuestIcon}
              moduleName={"Quest2Travel"}
              redirect={true}
              path={""}
              url={"https://www.quest2travel.in/frontend/emplogin"}
            />
            <ModuleBox
              icon={HelpdeskIcon}
              moduleName={"Helpdesk"}
              redirect={true}
              path={""}
              url={"https://sites.google.com/moreretail.in/hrhelpdesk/home"}
            />
            <ModuleBox
              icon={brandBayIcon}
              moduleName={"brandbay"}
              redirect={true}
              path={""}
              url={"https://brandbay.more.in/"}
            />
            <ModuleBox
              icon={LearnIcon}
              moduleName={"Learn"}
              redirect={true}
              path={""}
              url={"https://learn.more.in/"}
            />
          </div>
        </>
      )}
      {location.pathname === "/profile" && (
        <div className="border-top mt-12 pt-12">
          <div className="flex pf-head mt-12">
            <img src={ProfileIcon} alt="" />
            <div className="pf-head-text">Profile</div>
          </div>
          <div
            className={`module-box mb4 ${
              profileTabSelected === "overview" ? "active" : ""
            }`}
            onClick={() =>
              dispatch(authActions.setProfileTabSelected("overview"))
            }
          >
            <div className="module-name">Overview</div>
          </div>
          <div
            className={`module-box mb4 ${
              profileTabSelected === "personal" ? "active" : ""
            }`}
            onClick={() =>
              dispatch(authActions.setProfileTabSelected("personal"))
            }
          >
            <div className="module-name">Personal Details</div>
          </div>
          {/* <div
            className={`module-box mb4 ${profileTabSelected === "employment" ? "active" : ""
              }`}
            onClick={() =>
              dispatch(authActions.setProfileTabSelected("employment"))
            }
          >
            <div className="module-name">Employment Details</div>
          </div>
          <div
            className={`module-box mb4 ${profileTabSelected === "confirm" ? "active" : ""
              }`}
            onClick={() =>
              dispatch(authActions.setProfileTabSelected("confirm"))
            }
          >
            <div className="module-name">Confirmation</div>
          </div> */}
        </div>
      )}
      {(location.pathname !== "/profile" && (
        <div className="user-warpper w-full">
          {/* <div className="module-box">
            <img className="pr-img" src={HelpImg} alt="" />
            <div className="pr-fullName">Help</div>
          </div> */}
          <div
            className="module-box position-relative cursor-pointer"
            onClick={() => {
              setProfileDrop(!profileDrop);
            }}
          >
            <div className="profile-wrapper">
              <InitialsCircle fullName={fullName} size={32} type="profile" />
            </div>
            <div className="pr-fullName">{fullName}</div>
          </div>
          {profileDrop && (
            <div className="flex flex-col profile-drop">
              <div
                className="profile-drop-text"
                onClick={() => {
                  dispatch(authActions.setProfileTabSelected("overview"));
                  dispatch(
                    getUserDetails({
                      employee_id: employeeID,
                      user_type: roleType,
                    }),
                  );

                  setProfileDrop(!profileDrop);
                }}
              >
                View Profile
              </div>
              <div
                className="profile-drop-text"
                onClick={() => {
                  dispatch(authActions.setInitialState());
                  dispatch(peopleActions.setInitialState());
                  dispatch(modalActions.setInitialState());
                  dispatch(loadingActions.setInitialState());
                  dispatch(managerActions.setInitialState());
                  dispatch(requestActions.setInitialState());
                  dispatch(authActions.logout());
                  if (process.env.NODE_ENV === "production") {
                    {
                      const url =
                        process.env.REACT_APP_ENV === "UAT"
                          ? "https://people-uat.more.in/"
                          : "https://people.more.in/";
                      SSOAuthorization.logout(url)
                        .then(() => {
                          console.log("Logged out successfully");
                        })
                        .catch((error) => {
                          console.error("Logout failed", error);
                        });
                    }
                  }
                }}
              >
                Logout
              </div>
            </div>
          )}
        </div>
      )) ||
        ""}
    </div>
  );
};
export default SideBar;
